import { SxProps, Theme } from '@mui/material/styles'
import { isEmpty } from 'lodash'

import CowmedChip from '#/components/Chip'
import Colors from '#/styles/Colors'

export type FarmTaskStatus = {
  status: string
  text: string
}

interface TypeFarmTaskStatusProps {
  value: FarmTaskStatus
  sx: SxProps<Theme>
}

/**
 * Eu ou quem ver isso no futuro, desculpe a gambiarra.
 * A galera fuma umas drogas muito pesadas e faz a gente criar coisas repetidas.
 * A ideia era termos um componente status na qual tem todos os tipos, saude, reprodução, protocolo, contrato e etc.
 *
 * TypeSanitaryProtocolStatus é idêntico a esse.
 */
export function TypeFarmTaskStatus({ sx, value }: TypeFarmTaskStatusProps) {
  if (isEmpty(value)) return '-'

  const { status, text } = value
  return <CowmedChip value={text} width={'unset'} style={Colors.status[status]} sx={sx} />
}
